import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";
import SvgIcon from "../../../../parts/SvgIcon";

const AssignWorkoutFolderModal = ({ locals }) => {
	const { t } = useTranslation("coaching-portal");
	const { query = {}, workoutFolders = [] } = locals;
	const workoutId = query.cycleId || query.workoutId;

	const currentFolder = workoutFolders.find((f) =>
		(f.workoutIds || []).some((id) => String(id) === String(workoutId)),
	);

	const [selectedFolderId, setSelectedFolderId] = useState(
		currentFolder ? String(currentFolder._id) : "",
	);
	const [submitting, setSubmitting] = useState(false);

	const closeModal = () => {
		submit("/actions/refresh", {
			method: "GET",
			body: { modal: "", cycleId: "", workoutId: "" },
		});
	};

	const handleSave = () => {
		if (!workoutId || submitting) return;
		setSubmitting(true);
		submit("/actions/workout-folders/assign", {
			method: "POST",
			body: {
				folderId: selectedFolderId,
				workoutId,
			},
		});
	};

	return (
		<Modal
			className="workout-folder-modal assign-workout-folder-modal"
			title={t(
				"allTemplates.workoutFolders.assignFolderTitle",
				"Assign Folder",
			)}
			toClear={["cycleId", "workoutId"]}
		>
			<div className="body">
				<p className="assign-workout-folder-hint">
					{t(
						"allTemplates.workoutFolders.assignFolderHint",
						"Choose a folder for this workout. Selecting Uncategorized removes it from any folder.",
					)}
				</p>
				<ul className="assign-workout-folder-list">
					<li>
						<label className="assign-workout-folder-option">
							<input
								type="radio"
								name="assign-folder"
								value=""
								checked={selectedFolderId === ""}
								onChange={() => setSelectedFolderId("")}
							/>
							<span className="assign-workout-folder-option-name">
								{t(
									"allTemplates.workoutFolders.uncategorizedOption",
									"Uncategorized",
								)}
							</span>
						</label>
					</li>
					{workoutFolders.map((folder) => (
						<li key={folder._id}>
							<label className="assign-workout-folder-option">
								<input
									type="radio"
									name="assign-folder"
									value={folder._id}
									checked={selectedFolderId === String(folder._id)}
									onChange={() => setSelectedFolderId(String(folder._id))}
								/>
								<span className="assign-workout-folder-option-main">
									<SvgIcon
										src="/img/new-icons/folder.svg"
										classNames="assign-workout-folder-option-icon"
									/>
									<span className="assign-workout-folder-option-text">
										<span className="assign-workout-folder-option-name">
											{folder.name}
										</span>
										{folder.description ? (
											<span className="assign-workout-folder-option-description">
												{folder.description}
											</span>
										) : null}
									</span>
								</span>
							</label>
						</li>
					))}
				</ul>
				{workoutFolders.length === 0 && (
					<p className="assign-workout-folder-empty">
						{t(
							"allTemplates.workoutFolders.noFoldersToAssign",
							"No folders yet. Create a folder first.",
						)}
					</p>
				)}
			</div>
			<footer>
				<button
					type="button"
					data-button-type="secondary"
					data-action="cancel"
					onClick={closeModal}
				>
					{t("allTemplates.workoutFolders.cancel", "Cancel")}
				</button>
				<button
					type="button"
					data-button-type="primary"
					disabled={!workoutId || submitting}
					onClick={handleSave}
				>
					{t("allTemplates.workoutFolders.save", "Save")}
				</button>
			</footer>
		</Modal>
	);
};

AssignWorkoutFolderModal.propTypes = {
	locals: PropTypes.object.isRequired,
};

export default AssignWorkoutFolderModal;
